import { Route, Routes } from 'react-router-dom';

function NamespacedRouting({
  children,
  namespace = 'ui/*',
}: {
  children: JSX.Element;
  namespace?: string | ReadonlyArray<string> | string[];
}) {
  const namespaces = (Array.isArray(namespace) ? [...namespace] : [namespace]) as string[];
  return (
    <Routes>
      {namespaces.map(ns => (
        <Route key={ns} path={ns} element={children} />
      ))}
    </Routes>
  );
}

export default NamespacedRouting;
